import React from 'react';
import { Box, SxProps, Theme } from '@mui/material';
import { TableRowBone } from '../../molecules/TableRowBone/TableRowBone';

interface TableGridBoneProps {
    /** Nombre de colonnes */
    columns?: number;
    /** Nombre de lignes */
    rows?: number;
    /** Afficher l'en-tête */
    withHeader?: boolean;
    /** Styles personnalisés */
    sx?: SxProps<Theme>;
}

export const TableGridBone: React.FunctionComponent<TableGridBoneProps> = function ({
    columns = 4,
    rows = 8,
    withHeader = true,
    sx = {},
}) {
    return (
        <Box sx={{ width: '100%', padding: '16px', ...sx }}>
            {Array.from({ length: rows }).map((_, rowIndex) => (
                <TableRowBone
                    key={`table-row-${rows}-${rowIndex + 1}`}
                    columns={columns}
                    isHeader={rowIndex === 0 && withHeader}
                />
            ))}
        </Box>
    );
};
